<template>
  <el-dialog
    :visible="show"
    @update:visible="updateVisiable($event)"
    width="410px"
    :show-close="true"
    :top="top"
    class="hint_dialog"
  >
    <div class="dialog_content">
      <div class="hint_message">
        {{promptContent}}
      </div>
      <div class="dialog_btn">
        <el-button
            @click="goRegist"
            style="width: 140px;height: 100%;background: #e76606;border: none;color: #FFFFFF;border-radius: 8px;">{{lang.register}}</el-button>
        <el-button
          @click="handleConfirm"
          style="width: 140px;height: 100%;background: #3675fe;border: none;color: #FFFFFF;border-radius: 8px;">{{lang.login}}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import {language} from "../../language/get";

  export default {
    data() {
      return{lang: language()}
    },
    props: {
      loginData: {
        type: Object,
        default: () => {}
      },
      top: {
        type: String,
        default: "30vh"
      },
      show: {
        type: Boolean,
        default: false
      },
      title: {
        type: String
      },
      promptContent: {
        type: String,
        default: ""
      },
      type: {
        type: Number,
        default: null
      }
    },
    methods: {
      updateVisiable(v) {
        this.$emit("update:show", v);
      },
      //1.跳转到登录页
      handleConfirm() {
        this.$emit("confirm", this.type, this.loginData);
      },
      //注册
      goRegist() {
        if(this.type == 4){
          this.loginData.type = 4;
        }
        if(this.type == 9999){
          this.loginData.type = 9999;
        }
        if(this.type == 8888){
          this.loginData.type = 8888;
        }
        window.location.href = "register.html?type=" + this.loginData.type + "&exhibitionId=" + this.loginData.exhibitionId;
      }
    }
  }
</script>

<style scoped>
  .hint_dialog .dialog_content{
    box-sizing: border-box
  }

.dialog_btn {
  height: 40px;
  margin: auto;
  margin-top: 60px;
  display: flex;
  justify-content: space-between;
}

.hint_message {
  color: #424242;
  font-size: 17px;
  text-align: center;
  font-family: AdobeHeitiStd-Regular;
  margin-top: 35px;
}
</style>
<style>
  .hint_dialog .el-dialog__title {
    font-size: 14px !important;
  }
  .hint_dialog .el-dialog__body {
    padding: 0 20px 12px 20px !important;
  }
  .hint_dialog .el-dialog{
    padding: 9px 20px 18px 20px;
    border-radius: 10px

  }
  .hint_dialog .el-dialog .el-dialog__header {
    padding: 0 !important;
    /*border-bottom: 1px solid #AAAAAA !important;*/
    height: 15px !important;
    line-height: 15px !important;
  }
  .el-dialog__headerbtn .el-icon-close {
    background: #0c6dce;
    border-radius: 50%;
    height: 20px;
    width: 20px;
  }

</style>
